export default __webpack_public_path__ + "static/media/baga beach1.49bc417e.jpg";